import { formatMrGenericConnectionResource } from "areas/verifications/helpers/mr-generic";
import { Tag } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const manualCsv: IIngestionSourceData = {
  displayName: "Manual CSV",
  isEcom: false,
  isAutomated: false,
  parsedDataFormatter: formatMrGenericConnectionResource,
  listInventory: {
    linkHref: "/listInventory/manual",
    icon: Tag
  }
}

export default manualCsv